module.exports = __webpack_public_path__ + "static/media/AnvilSquad.abe468b9.jpg";